import InitData from './InitData';
import BetslipConf from './data/betslip/BetslipConf';
import BetslipSelectionsConf from './data/betslip/BetslipSelectionsConf';
import BonusConf from './data/betslip/BonusConf';
import UserConf from './data/betslip/UserConf';
import CashoutConfigurationCtx from './data/cashout/CashoutConfigurationCtx';
import ControlPanelConf from './data/control-panel-context/ControlPanelConf';
import FastbetConf from './data/fastbet/FastbetConf';
import LandingRequestedOpsConf from './data/landing/LandingRequestedOpsConf';
import ShopReceiptPrinterConf from './data/printer/ShopReceiptPrinterConf';
import TicketPrinterConf from './data/printer/TicketPrinterConf';
import PvrConf from './data/pvr/PvrConf';
import ShopConf from './data/shop/ShopConf';
import Container from './Container';
import { ErrorBoundary } from './common/ErrorBoundary';
import ErrorMessageWithLink from './common/ErrorMessageWithLink';

import './css/index-desktop.min.css';

function Main() {
    return (
        <ErrorBoundary fallback={<ErrorMessageWithLink />}>
            <InitData>
                <LandingRequestedOpsConf section={null}>
                    <ShopReceiptPrinterConf>
                        <ShopConf useSocket={false}>
                            <CashoutConfigurationCtx>
                                <PvrConf>
                                    <UserConf frontendVersion={"desktop"}>
                                        <ControlPanelConf>
                                            <TicketPrinterConf>
                                                <FastbetConf>
                                                    <BonusConf>
                                                        <BetslipConf xsportDesktop2={true} doubleProfileDefaultChoice={window.appConfig? window.appConfig.doubleProfileDefaultChoice : null} >
                                                            <BetslipSelectionsConf>
                                                                <Container />
                                                            </BetslipSelectionsConf>
                                                        </BetslipConf>
                                                    </BonusConf>
                                                </FastbetConf>
                                            </TicketPrinterConf>
                                        </ControlPanelConf>
                                    </UserConf>
                                </PvrConf>
                            </CashoutConfigurationCtx>
                        </ShopConf>
                    </ShopReceiptPrinterConf>
                </LandingRequestedOpsConf>
            </InitData>
        </ErrorBoundary>
    );
}

export default Main;